var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.235,
    height: 33.714,
    viewBox: "0 0 36.235 33.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "office365",
    transform: "translate(-0.1 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M78.7,34.2H92.667v8.443H78.7Z",
    transform: "translate(-56.332 -21.286)",
    fill: "#21a365"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M78.7,64H92.667v8.443H78.7Z",
    transform: "translate(-56.332 -42.643)",
    fill: "#107c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M29.5,34.2H43.439v8.443H29.5Z",
    transform: "translate(-21.071 -21.286)",
    fill: "#107c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M43.511,72.443V64H29.6V79.214a1.644,1.644,0,0,0,1.643,1.643H55.806a1.644,1.644,0,0,0,1.643-1.643V72.443Z",
    transform: "translate(-21.142 -42.643)",
    fill: "#185b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M90.924,4.5H78.6v8.443h14v-6.8A1.688,1.688,0,0,0,90.924,4.5Z",
    transform: "translate(-56.26)",
    fill: "#33c481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M43.582,4.5H31.343A1.644,1.644,0,0,0,29.7,6.143v6.771H43.611V4.5Z",
    transform: "translate(-21.214 0)",
    fill: "#21a365"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M16.929,49.915H1.913A1.826,1.826,0,0,1,.1,48.1V33.313A1.826,1.826,0,0,1,1.913,31.5H16.929a1.826,1.826,0,0,1,1.813,1.813V48.1A1.808,1.808,0,0,1,16.929,49.915Z",
    transform: "translate(0 -19.351)",
    fill: "#17864c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(5.285 16.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M24.661,56.671l-1.1-2.012c-.453-.793-.737-1.332-1.048-1.927H22.48c-.255.595-.51,1.133-.935,1.927l-.992,2.012H18.4l3.06-5.128L18.485,46.5h2.181l1.1,2.1c.34.623.595,1.133.85,1.7h.057c.283-.623.482-1.077.822-1.7l1.1-2.1h2.153l-3.031,4.958,3.145,5.213Z",
    transform: "translate(-18.4 -46.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M40.684,37.3V52.259a1.826,1.826,0,0,1-1.813,1.813H30.4v1.615h9.973a1.826,1.826,0,0,0,1.813-1.813V39.085A1.755,1.755,0,0,0,40.684,37.3Z",
    transform: "translate(-21.716 -23.507)",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/Excel_Icon.e176b7064e5f3b9df308127240f8c48c.svg";
export { ForwardRef as ReactComponent };